module.exports = __webpack_public_path__ + "img/cijengkol.32706f71.svg";